import { jsxs as e, Fragment as c, jsx as t } from "react/jsx-runtime";
import { a as r, b as o } from "./createIcon-C5WAZMGa.mjs";
const h = /* @__PURE__ */ r(
  /* @__PURE__ */ e(c, { children: [
    /* @__PURE__ */ t(
      "path",
      {
        d: "M12 5C12.5523 5 13 4.55228 13 4C13 3.44772 12.5523 3 12 3C11.4477 3 11 3.44772 11 4C11 4.55228 11.4477 5 12 5Z M19.25 18.45C19.8271 18.3402 20.246 17.8375 20.25 17.25C20.2554 16.9787 20.1671 16.7138 20 16.5L18 14.5V9.00002C17.5309 6.06795 14.9686 3.93273 12 4.00002C9.0314 3.93273 6.46914 6.06795 6 9.00002V14.48L4 16.48C3.82212 16.6898 3.72309 16.955 3.72 17.23C3.72397 17.8175 4.14286 18.3202 4.72 18.43 M12 21C13.1046 21 14 20.1046 14 19H10C10 20.1046 10.8954 21 12 21Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ t("rect", { x: "11", y: "4", width: "2", height: "2", fill: "currentColor" })
  ] }),
  "AlertIcon"
), d = /* @__PURE__ */ r(
  /* @__PURE__ */ t(c, { children: /* @__PURE__ */ e("g", { fill: "currentColor", children: [
    /* @__PURE__ */ t("rect", { width: "4", height: "15", x: "3", y: "6" }),
    /* @__PURE__ */ t("rect", { width: "4", height: "15", x: "17", y: "6" }),
    /* @__PURE__ */ t("rect", { width: "18", height: "3", x: "3", y: "18" }),
    /* @__PURE__ */ t("rect", { width: "18", height: "5", x: "3", y: "6" }),
    /* @__PURE__ */ t("polygon", { points: "3,6 4,4 5,4 5,6" }),
    /* @__PURE__ */ t("rect", { width: "16", height: "1", x: "4", y: "4" }),
    /* @__PURE__ */ t("polygon", { points: "21,6 20,4 19,4 19,6" }),
    /* @__PURE__ */ t("polygon", { points: "3,21 7,14 12,18 7,21" }),
    /* @__PURE__ */ t("polygon", { points: "21,21 17,14 12,18 7,21" }),
    /* @__PURE__ */ t("polygon", { points: "7,14 7,10 10,10 10,14 10,14" }),
    /* @__PURE__ */ t("polygon", { points: "17,14 17,10 14,10 14,14 10,14" })
  ] }) }),
  "ArchiveIcon"
), C = /* @__PURE__ */ r(
  /* @__PURE__ */ e(c, { children: [
    /* @__PURE__ */ t("rect", { fill: "currentColor", x: "7", y: "11", width: "13", height: "2" }),
    /* @__PURE__ */ t(
      "rect",
      {
        fill: "currentColor",
        x: "7",
        y: "7",
        width: "9",
        transform: "rotate(-45 12 12)",
        height: "2"
      }
    ),
    /* @__PURE__ */ t(
      "rect",
      {
        fill: "currentColor",
        x: "7",
        y: "15",
        width: "9",
        transform: "rotate(45 12 12)",
        height: "2"
      }
    )
  ] }),
  "ArrowIcon"
), a = /* @__PURE__ */ r(
  /* @__PURE__ */ e(c, { children: [
    /* @__PURE__ */ t("rect", { fill: "currentColor", x: "7", y: "11", width: "13", height: "2" }),
    /* @__PURE__ */ t(
      "rect",
      {
        fill: "currentColor",
        x: "7",
        y: "7",
        width: "9",
        transform: "rotate(-45 12 12)",
        height: "2"
      }
    ),
    /* @__PURE__ */ t(
      "rect",
      {
        fill: "currentColor",
        x: "7",
        y: "15",
        width: "9",
        transform: "rotate(45 12 12)",
        height: "2"
      }
    )
  ] }),
  "ArrowLeftIcon"
), s = /* @__PURE__ */ r(
  /* @__PURE__ */ e("g", { transform: "rotate(180 12 12)", children: [
    /* @__PURE__ */ t("rect", { fill: "currentColor", x: "7", y: "11", width: "13", height: "2" }),
    /* @__PURE__ */ t(
      "rect",
      {
        fill: "currentColor",
        x: "7",
        y: "7",
        width: "9",
        transform: "rotate(-45 12 12)",
        height: "2"
      }
    ),
    /* @__PURE__ */ t(
      "rect",
      {
        fill: "currentColor",
        x: "7",
        y: "15",
        width: "9",
        transform: "rotate(45 12 12)",
        height: "2"
      }
    )
  ] }),
  "ArrowRightIcon"
), p = /* @__PURE__ */ r(
  /* @__PURE__ */ e(c, { children: [
    /* @__PURE__ */ t(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17.3757 12.503L10.9363 6.06368L13.0577 3.94236L21.6183 12.503L13.0577 21.0637L10.9363 18.9424L17.3757 12.503Z",
        fill: "#1A1A1A"
      }
    ),
    /* @__PURE__ */ t("path", { d: "M3 11H18V14H3V11Z", fill: "currentColor" })
  ] }),
  "ArrowThickIcon"
), H = /* @__PURE__ */ r(
  /* @__PURE__ */ t(
    "path",
    {
      fill: "currentColor",
      d: `M16.5,6
  v12
  q0,3.5 -4,3.5
  q-4,0 -4,-3.5
  v-12
  q0,-3.5 2.5,-3.5
  q2.5,0 2.5,3.5
  v10
  q0,1 -1,1
  q-1,0 -1,-1
  v-10
  h-1.5
  v10
  q0,2.5 2.5,2.5
  q2.5,0 2.5,-2.5
  v-10
  q0,-5 -4,-5
  q-4,0 -4,5
  v12
  q0,5 5,5
  q6,0 6,-5
  v-12
  `
    }
  ),
  "AttachmentIcon"
), V = /* @__PURE__ */ r(
  /* @__PURE__ */ e("g", { children: [
    /* @__PURE__ */ t(
      "path",
      {
        d: "M3 6H5H21",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ t(
      "path",
      {
        d: "M8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6M19 6V20C19 20.5304 18.7893 21.0391 18.4142 21.4142C18.0391 21.7893 17.5304 22 17 22H7C6.46957 22 5.96086 21.7893 5.58579 21.4142C5.21071 21.0391 5 20.5304 5 20V6H19Z",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ t(
      "path",
      {
        d: "M10 11V17",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ t(
      "path",
      {
        d: "M14 11V17",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  ] }),
  "BinIcon"
), u = /* @__PURE__ */ r(
  /* @__PURE__ */ e("g", { fill: "currentColor", children: [
    /* @__PURE__ */ t("rect", { width: "7", height: "6", x: "3", y: "15" }),
    /* @__PURE__ */ t("rect", { width: "6", height: "5", x: "9", y: "16" }),
    /* @__PURE__ */ t("rect", { width: "7", height: "6", x: "14", y: "15" }),
    /* @__PURE__ */ t("rect", { width: "8", height: "6", x: "14", y: "8" }),
    /* @__PURE__ */ t("rect", { width: "8", height: "6", x: "2", y: "8" }),
    /* @__PURE__ */ t("rect", { width: "8", height: "4", x: "8", y: "8" }),
    /* @__PURE__ */ t("rect", { width: "2", height: "2", x: "8", y: "6" }),
    /* @__PURE__ */ t("rect", { width: "2", height: "2", x: "14", y: "6" }),
    /* @__PURE__ */ t("polygon", { points: "8,6 10,4, 14,4 16,6" })
  ] }),
  "BusinessCenterIcon"
), g = /* @__PURE__ */ r(
  /* @__PURE__ */ t(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5 22H19V3H5V22ZM7 8H17V5H7V8ZM15 12H17V10H15V12ZM11 12H13V10H11V12ZM7 12H9V10H7V12ZM15 16H17V14H15V16ZM11 16H13V14H11V16ZM7 16H9V14H7V16ZM15 20H17V18H15V20ZM11 20H13V18H11V20ZM7 20H9V18H7V20Z",
      fill: "currentColor"
    }
  ),
  "CalculatorIcon"
), f = /* @__PURE__ */ r(
  /* @__PURE__ */ t(
    "path",
    {
      d: "M21 3H18V1H16V3H8V1H6V3H3V21H21V3ZM19 19H5V8H19V19ZM7 10H12V15H7V10Z",
      fill: "currentColor"
    }
  ),
  "CalendarIcon"
), L = /* @__PURE__ */ r(
  /* @__PURE__ */ t(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M22 3H2V18H5L7 21L12 18H22V3ZM4 6H20V8H4V6ZM12 10H4V12H12V10Z",
      fill: "currentColor"
    }
  ),
  "ChatBubbleIcon"
), M = /* @__PURE__ */ r(
  /* @__PURE__ */ e(c, { children: [
    /* @__PURE__ */ e("defs", { children: [
      /* @__PURE__ */ t("clipPath", { id: "clip-bottom-right", children: /* @__PURE__ */ t(
        "rect",
        {
          transform: "rotate(320 12 12)",
          x: "0",
          y: "14",
          width: "24",
          height: "12"
        }
      ) }),
      /* @__PURE__ */ t("clipPath", { id: "clip-bottom-left", children: /* @__PURE__ */ t(
        "rect",
        {
          transform: "rotate(50 12 12)",
          x: "0",
          y: "16",
          width: "24",
          height: "12"
        }
      ) }),
      /* @__PURE__ */ t("clipPath", { id: "clip-left", children: /* @__PURE__ */ t(
        "rect",
        {
          transform: "rotate(140 12 12)",
          x: "0",
          y: "16",
          width: "24",
          height: "12"
        }
      ) }),
      /* @__PURE__ */ t("clipPath", { id: "clip-top-right", children: /* @__PURE__ */ t("rect", { transform: "rotate(-224 12 12)", x: "0", y: "9", width: "5", height: "7" }) }),
      /* @__PURE__ */ t("clipPath", { id: "clip-top-left", children: /* @__PURE__ */ t("rect", { transform: "rotate(50 12 12)", x: "0", y: "4", width: "12", height: "10" }) })
    ] }),
    /* @__PURE__ */ e("g", { fill: "currentColor", children: [
      /* @__PURE__ */ t("circle", { cx: "12", cy: "12", r: "10", clipPath: "url(#clip-bottom-right)" }),
      /* @__PURE__ */ t("circle", { cx: "12", cy: "12", r: "10", clipPath: "url(#clip-bottom-left)" }),
      /* @__PURE__ */ t("circle", { cx: "12", cy: "12", r: "10", clipPath: "url(#clip-left)" }),
      /* @__PURE__ */ t("circle", { cx: "12", cy: "12", r: "10", clipPath: "url(#clip-top-right)" }),
      /* @__PURE__ */ t("circle", { cx: "12", cy: "12", r: "10", clipPath: "url(#clip-top-left)" })
    ] })
  ] }),
  "CheckmarkCircleIcon"
), I = /* @__PURE__ */ r(
  /* @__PURE__ */ t(
    "path",
    {
      d: "M19 5L10 14L6.5 10.5L4 13L10 19L21.5 7.5L19 5Z",
      fill: "currentColor"
    }
  ),
  "CheckmarkIcon"
), y = /* @__PURE__ */ r(
  /* @__PURE__ */ t("path", { d: "M18 9L12 15L6 9", stroke: "currentColor", strokeWidth: "2" }),
  "ChevronIcon"
), x = /* @__PURE__ */ r(
  /* @__PURE__ */ t("path", { d: "M15 6L9 12L15 18", stroke: "currentColor", strokeWidth: "2" }),
  "ChevronLeftIcon"
), Z = /* @__PURE__ */ r(
  /* @__PURE__ */ t("path", { d: "M9 6L15 12L9 18", stroke: "currentColor", strokeWidth: "2" }),
  "ChevronRightIcon"
), w = /* @__PURE__ */ r(
  /* @__PURE__ */ t(
    "path",
    {
      d: "M15.5996 16.85L16.8246 15.625L12.8996 11.675V6.69998H11.2496V12.325L15.5996 16.85ZM11.9996 22.15C10.6163 22.15 9.30378 21.8833 8.06211 21.35C6.82044 20.8166 5.74128 20.0916 4.82461 19.175C3.90794 18.2583 3.18294 17.1791 2.64961 15.9375C2.11628 14.6958 1.84961 13.3833 1.84961 12C1.84961 10.6166 2.11628 9.30414 2.64961 8.06248C3.18294 6.82081 3.90794 5.74164 4.82461 4.82498C5.74128 3.90831 6.82044 3.18331 8.06211 2.64998C9.30378 2.11664 10.6163 1.84998 11.9996 1.84998C13.3829 1.84998 14.6954 2.11664 15.9371 2.64998C17.1788 3.18331 18.2579 3.90831 19.1746 4.82498C20.0913 5.74164 20.8163 6.82081 21.3496 8.06248C21.8829 9.30414 22.1496 10.6166 22.1496 12C22.1496 13.3833 21.8829 14.6958 21.3496 15.9375C20.8163 17.1791 20.0913 18.2583 19.1746 19.175C18.2579 20.0916 17.1829 20.8166 15.9496 21.35C14.7163 21.8833 13.3996 22.15 11.9996 22.15Z",
      fill: "currentColor"
    }
  ),
  "ClockIcon"
), k = /* @__PURE__ */ r(
  /* @__PURE__ */ t(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM15.2929 16.7072L12 13.4143L8.70712 16.7072L7.29291 15.293L10.5858 12.0001L7.29291 8.70718L8.70712 7.29297L12 10.5859L15.2929 7.29297L16.7071 8.70718L13.4142 12.0001L16.7071 15.293L15.2929 16.7072Z",
      fill: "currentColor"
    }
  ),
  "CloseIcon"
), m = /* @__PURE__ */ r(
  /* @__PURE__ */ e(c, { children: [
    /* @__PURE__ */ e("g", { fill: "currentColor", children: [
      /* @__PURE__ */ t("rect", { width: "2", height: "16", x: "2", y: "4" }),
      /* @__PURE__ */ t("rect", { width: "2", height: "16", x: "20", y: "4" }),
      /* @__PURE__ */ t("rect", { width: "20", height: "2", x: "2", y: "4" }),
      /* @__PURE__ */ t("rect", { width: "20", height: "2", x: "2", y: "18" }),
      /* @__PURE__ */ t("rect", { width: "19", height: "3", x: "2", y: "9" })
    ] }),
    ","
  ] }),
  "CreditCardIcon"
), R = /* @__PURE__ */ r(
  /* @__PURE__ */ t(
    "path",
    {
      d: "M18 3L12 9L5.999 3L3 6L9 12L3 18L5.999 21L12 15L18 21L21 18L14.999 12L21 6L18 3Z",
      fill: "currentColor"
    }
  ),
  "CrossIcon"
), v = /* @__PURE__ */ r(
  /* @__PURE__ */ e(c, { children: [
    /* @__PURE__ */ t("path", { d: "M8 5H3V19H8V5Z", fill: "currentColor" }),
    /* @__PURE__ */ t("path", { d: "M15 9H10V19H15V9Z", fill: "currentColor" }),
    /* @__PURE__ */ t("path", { d: "M17 12H22V19H17V12Z", fill: "currentColor" })
  ] }),
  "DecliningChartIcon"
), P = /* @__PURE__ */ r(
  /* @__PURE__ */ e(c, { children: [
    /* @__PURE__ */ t("path", { d: "M2 3V7H4V5H6V3H2Z", fill: "currentColor" }),
    /* @__PURE__ */ t("path", { d: "M22 3H18V5L20 5V7H22V3Z", fill: "currentColor" }),
    /* @__PURE__ */ t("path", { d: "M22 21H18V19H20V17H22V21Z", fill: "currentColor" }),
    /* @__PURE__ */ t("path", { d: "M2 21H6V19H4V17H2V21Z", fill: "currentColor" }),
    /* @__PURE__ */ t("path", { d: "M6 15H5V16H6V15Z", fill: "currentColor" }),
    /* @__PURE__ */ t("path", { d: "M7 16V15H8V16H7Z", fill: "currentColor" }),
    /* @__PURE__ */ t("path", { d: "M10 15H9V16H10V15Z", fill: "currentColor" }),
    /* @__PURE__ */ t("path", { d: "M11 15H12V16H11V15Z", fill: "currentColor" }),
    /* @__PURE__ */ t("path", { d: "M14 15H13V16H14V15Z", fill: "currentColor" }),
    /* @__PURE__ */ t("path", { d: "M15 15H16V16H15V15Z", fill: "currentColor" }),
    /* @__PURE__ */ t("path", { d: "M18 15H17V16H18V15Z", fill: "currentColor" }),
    /* @__PURE__ */ t("path", { d: "M19 15H20V16H19V15Z", fill: "currentColor" }),
    /* @__PURE__ */ t(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.4932 9.5822C9.62211 8.80871 9.59023 8.17409 9.31646 7.75693C9.16595 7.52757 8.94589 7.3723 8.68119 7.32147C8.43039 7.27332 8.18782 7.3277 7.98443 7.4181C7.58325 7.5964 7.21708 7.96368 6.95485 8.3977C6.68756 8.84011 6.5 9.39723 6.5 10C6.5 10.6659 6.55211 11.3287 6.73698 11.9199C5.90546 12.5057 4.97669 12.8654 4.37873 13.0149L4.62127 13.9851C5.28799 13.8184 6.27066 13.4413 7.18202 12.8275C7.74518 13.6011 8.66854 14 10 14C10.6348 14 11.8591 13.7093 12.7911 12.6859C12.8595 12.8842 12.9547 13.0834 13.084 13.2773C13.4128 13.7706 13.9799 13.9351 14.5113 13.9663C15.0539 13.9982 15.6788 13.9009 16.2955 13.7478C17.5347 13.4401 18.8705 12.8738 19.7236 12.4472L19.2764 11.5528C18.4628 11.9596 17.1987 12.4932 16.0545 12.7772C15.4796 12.92 14.9669 12.9914 14.57 12.968C14.1618 12.9441 13.9872 12.8294 13.916 12.7227C13.5704 12.2042 13.6097 11.5798 13.703 11.1819C13.7118 11.1616 13.7201 11.1422 13.728 11.1236C13.7846 10.99 13.8287 10.8725 13.8475 10.7882L13.8478 10.7869C13.8506 10.7749 13.8681 10.6997 13.8592 10.6112C13.8563 10.5828 13.8484 10.5262 13.82 10.4608C13.7916 10.3952 13.7244 10.2808 13.582 10.2104C13.432 10.1363 13.2889 10.155 13.2012 10.1842C13.1209 10.211 13.0666 10.2517 13.0416 10.2721C12.9636 10.3358 12.9209 10.4124 12.917 10.4194C12.9025 10.4441 12.8903 10.4687 12.8811 10.4882C12.8453 10.5648 12.8055 10.6733 12.7692 10.8001C12.7642 10.8177 12.7592 10.836 12.7541 10.8551C12.7047 10.965 12.6388 11.1043 12.5528 11.2764C11.8596 12.6628 10.5323 13 10 13C8.85468 13 8.2869 12.663 7.97212 12.2133L7.97108 12.2118C8.70013 11.5493 9.31026 10.6798 9.4932 9.5822ZM7.5 10C7.5 10.446 7.52644 10.842 7.5875 11.1874C8.05335 10.6878 8.3933 10.0988 8.5068 9.4178C8.62789 8.6913 8.53477 8.38842 8.48041 8.30558L8.47961 8.30436C8.464 8.30616 8.4349 8.31221 8.39057 8.33191C8.22925 8.40361 8.00167 8.59883 7.81077 8.91481C7.62494 9.2224 7.5 9.60277 7.5 10Z",
        fill: "currentColor"
      }
    )
  ] }),
  "DigitallySignIcon"
), A = /* @__PURE__ */ r(
  /* @__PURE__ */ t(
    "path",
    {
      d: "M13 2H5V22H19V8L13 2ZM16.5982 13.4354L10.9388 19.0948L7.40543 15.5615L8.82569 14.1412L10.9448 16.2603L15.184 12.0212L16.5982 13.4354ZM12 9V3.5L17.5 9H12Z",
      fill: "currentColor"
    }
  ),
  "DocumentDoneIcon"
), W = /* @__PURE__ */ r(
  /* @__PURE__ */ t(
    "path",
    {
      d: "M13 2H5V22H19V8L13 2ZM17 18H7V16H17V18ZM14 14H7V12H14V14ZM12 9V3.5L17.5 9H12Z",
      fill: "currentColor"
    }
  ),
  "DocumentFilledIcon"
), b = /* @__PURE__ */ r(
  /* @__PURE__ */ t("path", { d: "M14 2V7.999H19L14 2ZM5 2V22H19V9H13V2H5Z", fill: "currentColor" }),
  "DocumentIcon"
), T = /* @__PURE__ */ r(
  /* @__PURE__ */ t(
    "path",
    {
      d: "M10 2V10L6.999 6.999L5 9L10 14L12 15.999L14 14L19 9L17 6.999L14 10V2H10ZM18 15V19.001H5.999V15H3V22H21V15H18Z",
      fill: "currentColor"
    }
  ),
  "DownloadIcon"
), D = /* @__PURE__ */ r(
  /* @__PURE__ */ e(c, { children: [
    /* @__PURE__ */ t(
      "path",
      {
        d: "M15.2928 11.2929L13 13.5858V4H11V13.5858L8.70706 11.2929L7.29285 12.7071L12 17.4142L16.7071 12.7071L15.2928 11.2929Z",
        fill: "#1A1A1A"
      }
    ),
    /* @__PURE__ */ t("path", { d: "M6 14H4V21H20V14H18V19H6V14Z", fill: "currentColor" }),
    ","
  ] }),
  "DownloadInlineIcon"
), S = /* @__PURE__ */ r(
  /* @__PURE__ */ e(c, { children: [
    /* @__PURE__ */ t("path", { d: "M11 10V6H13V10H11Z", fill: "currentColor" }),
    /* @__PURE__ */ t(
      "path",
      {
        d: "M7.19239 11.6066L4.36396 8.77817L5.77817 7.36396L8.6066 10.1924L7.19239 11.6066Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ t(
      "path",
      {
        d: "M17.0919 11.6066L19.9203 8.77817L18.5061 7.36396L15.6777 10.1924L17.0919 11.6066Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ t("path", { d: "M6 16H2V14H6V16Z", fill: "currentColor" }),
    /* @__PURE__ */ t("path", { d: "M18 16H22V14H18V16Z", fill: "currentColor" }),
    /* @__PURE__ */ t(
      "path",
      {
        d: "M7 16C7 13.2386 9.23858 11 12 11C14.7614 11 17 13.2386 17 16H7Z",
        fill: "currentColor"
      }
    )
  ] }),
  "EnergyLoanIcon"
), q = /* @__PURE__ */ r(
  /* @__PURE__ */ e("g", { fill: "currentColor", children: [
    /* @__PURE__ */ t("rect", { width: "18", height: "5", x: "3", y: "3" }),
    /* @__PURE__ */ t("rect", { width: "18", height: "2", x: "3", y: "19" }),
    /* @__PURE__ */ t("rect", { width: "2", height: "18", x: "3", y: "3" }),
    /* @__PURE__ */ t("rect", { width: "2", height: "18", x: "19", y: "3" }),
    /* @__PURE__ */ t("rect", { width: "2", height: "2", x: "6", y: "1" }),
    /* @__PURE__ */ t("rect", { width: "2", height: "2", x: "16", y: "1" }),
    /* @__PURE__ */ t("rect", { width: "10", height: "2", x: "7", y: "10" }),
    /* @__PURE__ */ t("rect", { width: "7", height: "2", x: "7", y: "14" })
  ] }),
  "EventIcon"
), E = /* @__PURE__ */ r(
  /* @__PURE__ */ t(
    "path",
    {
      d: "M12 17.625V15.375M12 14.25L12 6.375M3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12Z",
      stroke: "currentColor",
      strokeWidth: "2"
    }
  ),
  "ExclamationRingIcon"
), U = /* @__PURE__ */ r(
  /* @__PURE__ */ t(c, { children: /* @__PURE__ */ e("g", { fill: "currentColor", children: [
    /* @__PURE__ */ t("rect", { height: "6", width: "2", x: "3", y: "3" }),
    /* @__PURE__ */ t("rect", { height: "6", width: "2", x: "3", y: "15" }),
    /* @__PURE__ */ t("rect", { height: "2", width: "18", x: "3", y: "3" }),
    /* @__PURE__ */ t("rect", { height: "2", width: "18", x: "3", y: "19" }),
    /* @__PURE__ */ t("rect", { height: "18", width: "2", x: "19", y: "3" }),
    /* @__PURE__ */ t("rect", { height: "2", width: "12", x: "3", y: "11" }),
    /* @__PURE__ */ t("rect", { height: "2", width: "7", x: "8", y: "9", transform: "rotate(45 12 12)" }),
    /* @__PURE__ */ t("rect", { height: "2", width: "7", x: "8", y: "13", transform: "rotate(-45 12 12)" })
  ] }) }),
  "ExitIcon"
), B = /* @__PURE__ */ r(
  /* @__PURE__ */ t(
    "path",
    {
      d: "M13 3V6H15.903L9.001 12.885L9.004 15.004L11.123 15.006L18 8.148V11H21V3H13ZM3 6V21H18V18H17.999L18 14H15L14.999 18H6V9H10V6H3Z",
      fill: "currentColor"
    }
  ),
  "ExternalLinkIcon"
), F = /* @__PURE__ */ r(
  /* @__PURE__ */ e(c, { children: [
    /* @__PURE__ */ t("path", { d: "M3.75 2.25H2.25V15.75H3.75V2.25Z", fill: "currentColor" }),
    /* @__PURE__ */ t("path", { d: "M9 2.25H2.25V3.75H9V2.25Z", fill: "currentColor" }),
    /* @__PURE__ */ t("path", { d: "M15.75 2.25H10.5V3.75H15.75V2.25Z", fill: "currentColor" }),
    /* @__PURE__ */ t("path", { d: "M15.75 14.25H2.25V15.75H15.75V14.25Z", fill: "currentColor" }),
    /* @__PURE__ */ t("path", { d: "M15.75 2.25H14.25V7.5H15.75V2.25Z", fill: "currentColor" }),
    /* @__PURE__ */ t("path", { d: "M15.75 9H14.25V15.75H15.75V9Z", fill: "currentColor" }),
    /* @__PURE__ */ t(
      "path",
      {
        d: "M13.7733 3.16638L6.34863 10.591L7.40929 11.6517L14.8339 4.22704L13.7733 3.16638Z",
        fill: "currentColor"
      }
    )
  ] }),
  "ExternalLinkInlineIcon"
), j = /* @__PURE__ */ r(
  /* @__PURE__ */ t(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M20 2H4V22H20V2ZM7.5 7C8.32843 7 9 6.32843 9 5.5C9 4.67157 8.32843 4 7.5 4C6.67157 4 6 4.67157 6 5.5C6 6.32843 6.67157 7 7.5 7ZM10 5H18V6H10V5ZM18 9H6V10H18V9ZM14 11V12H6V11H14ZM18 14H6V20H18V14Z",
      fill: "currentColor"
    }
  ),
  "FeedIcon"
), G = /* @__PURE__ */ r(
  /* @__PURE__ */ t("g", { fill: "currentColor", children: /* @__PURE__ */ t("circle", { cx: "12", cy: "12", r: "8" }) }),
  "FiberManualRecordIcon"
), O = /* @__PURE__ */ r(
  /* @__PURE__ */ t(
    "path",
    {
      d: "M5 19H8V13H5V19ZM16 19H19V5H16V19ZM10.55 19H13.55V9.2H10.55V19Z",
      fill: "currentColor"
    }
  ),
  "GraphIcon"
), N = /* @__PURE__ */ r(
  /* @__PURE__ */ t(
    "path",
    {
      d: "M18.2778 7.71273C18.1828 7.64773 18.0788 7.60573 17.9808 7.54873C17.8478 5.80873 16.9628 4.13973 15.4158 3.06773C12.6918 1.18173 8.95484 1.85973 7.06784 4.58473C6.01284 6.10773 5.76184 7.94673 6.21984 9.60373C5.96384 9.79273 5.72584 10.0167 5.53384 10.2927C4.59084 11.6547 4.92984 13.5247 6.29284 14.4677C7.45784 15.2747 8.98984 15.1357 10.0008 14.2277V22.0007H14.0008V14.4427C15.7858 15.4817 18.0918 15.0057 19.2888 13.2777C20.5468 11.4627 20.0938 8.97073 18.2778 7.71273Z",
      fill: "currentColor"
    }
  ),
  "GreenMortgageIcon"
), Q = /* @__PURE__ */ r(
  /* @__PURE__ */ t(
    "path",
    {
      d: "M1 7H23V4H1V7ZM1 14H23V11H1V14ZM1 21H23V18H1V21Z",
      fill: "currentColor"
    }
  ),
  "HamburgerMenuIcon"
), X = /* @__PURE__ */ r(
  /* @__PURE__ */ t(
    "path",
    {
      d: "M16.997 3C15.6712 3 14.3997 3.55492 13.4622 4.54267C12.5247 5.53043 11.998 6.87011 11.998 8.26701C11.998 6.87011 11.4714 5.53043 10.5339 4.54267C9.59636 3.55492 8.32484 3 6.99902 3C5.67319 3 4.40167 3.55492 3.46418 4.54267C2.52668 5.53043 2 6.87011 2 8.26701C2.00112 8.95981 2.13196 9.64556 2.38501 10.285C2.63807 10.9244 3.00837 11.505 3.47471 11.9934L11.998 21L20.5338 11.9934C21.2338 11.2568 21.7105 10.3179 21.9037 9.29569C22.0969 8.27345 21.9979 7.21378 21.6192 6.25085C21.2406 5.28792 20.5992 4.46502 19.7764 3.88633C18.9536 3.30764 17.9863 2.99918 16.997 3Z",
      fill: "currentColor"
    }
  ),
  "HeartIcon"
), z = /* @__PURE__ */ r(
  /* @__PURE__ */ e("g", { fill: "currentColor", children: [
    /* @__PURE__ */ t("rect", { width: "5", height: "8", x: "5", y: "12" }),
    /* @__PURE__ */ t("rect", { width: "5", height: "8", x: "14", y: "12" }),
    /* @__PURE__ */ t("rect", { width: "10", height: "2", x: "5", y: "12" }),
    /* @__PURE__ */ t("polygon", { points: "2,13 12,3 22,13" })
  ] }),
  "HomeIcon"
), J = /* @__PURE__ */ r(
  /* @__PURE__ */ t(c, { children: /* @__PURE__ */ e("g", { fill: "currentColor", children: [
    /* @__PURE__ */ t("rect", { width: "2", height: "10", x: "13", y: "11" }),
    /* @__PURE__ */ t("rect", { width: "14", height: "2", x: "1", y: "19" }),
    /* @__PURE__ */ t("rect", { width: "2", height: "10", x: "1", y: "11" }),
    /* @__PURE__ */ t("rect", { width: "4", height: "7", x: "6", y: "13" }),
    /* @__PURE__ */ t(
      "rect",
      {
        width: "2",
        height: "8",
        x: "3.5",
        y: "11",
        transform: "rotate(45 12 12)"
      }
    ),
    /* @__PURE__ */ t(
      "rect",
      {
        width: "2",
        height: "10",
        x: "12.8",
        y: "3.5",
        transform: "rotate(-45 12 12)"
      }
    ),
    /* @__PURE__ */ t("rect", { width: "6", height: "2", x: "17", y: "19" }),
    /* @__PURE__ */ t("rect", { width: "2", height: "18", x: "21", y: "3" }),
    /* @__PURE__ */ t("rect", { width: "10", height: "2", x: "12", y: "3" }),
    /* @__PURE__ */ t("rect", { width: "2", height: "2", x: "17", y: "7" }),
    /* @__PURE__ */ t("rect", { width: "2", height: "2", x: "17", y: "11" }),
    /* @__PURE__ */ t("rect", { width: "2", height: "2", x: "17", y: "15" }),
    /* @__PURE__ */ t("polygon", { points: "13,7 15,7, 15,9" }),
    /* @__PURE__ */ t("polygon", { points: "10,3 12,3, 12,5" })
  ] }) }),
  "HomeWorkIcon"
), K = /* @__PURE__ */ r(
  /* @__PURE__ */ t(
    "path",
    {
      d: "M12 2L3 11L5 13L6 12L6.009 22H18V12L19 13L21 11L12 2Z",
      fill: "currentColor"
    }
  ),
  "HouseIcon"
), Y = /* @__PURE__ */ r(
  /* @__PURE__ */ e(c, { children: [
    /* @__PURE__ */ t(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14 12V18H10V12H14Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ t("path", { d: "M13 8L17 4L21 8H19V18H15V8H13Z", fill: "currentColor" }),
    /* @__PURE__ */ t(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9 12V18H5V12H9Z",
        fill: "currentColor"
      }
    )
  ] }),
  "IncreaseMortgageIcon"
), _ = /* @__PURE__ */ r(
  /* @__PURE__ */ e(c, { children: [
    /* @__PURE__ */ e("defs", { children: [
      /* @__PURE__ */ t("clipPath", { id: "clip-1", children: /* @__PURE__ */ t("rect", { x: "13", y: "0", width: "24", height: "24" }) }),
      /* @__PURE__ */ t("clipPath", { id: "clip-2", children: /* @__PURE__ */ t("rect", { x: "0", y: "0", width: "11", height: "24" }) })
    ] }),
    /* @__PURE__ */ t(
      "circle",
      {
        id: "circle",
        cx: "12",
        cy: "11",
        r: "40%",
        fill: "currentColor",
        style: { clipPath: "url(#clip-1)" },
        stroke: "currentColor"
      }
    ),
    /* @__PURE__ */ t(
      "circle",
      {
        id: "circle",
        cx: "12",
        cy: "11",
        r: "40%",
        fill: "currentColor",
        style: { clipPath: "url(#clip-2)" },
        stroke: "currentColor"
      }
    ),
    /* @__PURE__ */ t("rect", { fill: "currentColor", width: "2.2", height: "5.06", x: "10.9", y: "16" }),
    /* @__PURE__ */ t("rect", { fill: "currentColor", width: "2.2", height: "5", x: "10.9", y: ".965" }),
    /* @__PURE__ */ t("rect", { fill: "currentColor", width: "2.2", height: "2", x: "10.9", y: "8" })
  ] }),
  "InfoCircleIcon"
), $ = /* @__PURE__ */ r(
  /* @__PURE__ */ t(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 9C10.896 9 10 8.104 10 7C10 5.896 10.896 5 12 5C13.104 5 14 5.896 14 7C14 8.104 13.104 9 12 9ZM10 19H14V11H10V19ZM5 22H19V2H5V22Z",
      fill: "currentColor"
    }
  ),
  "InfoIcon"
), t1 = /* @__PURE__ */ r(
  /* @__PURE__ */ t(
    "path",
    {
      d: "M12 6.375V8.625M12 9.75L12 17.625M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z",
      stroke: "currentColor",
      strokeWidth: "2"
    }
  ),
  "InfoRingIcon"
), r1 = /* @__PURE__ */ r(
  /* @__PURE__ */ t(
    "path",
    {
      d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z M11.112 13.0719H12.896V6.2959H11.112V13.0719ZM12.008 17.2319C12.64 17.2319 13.152 16.7039 13.152 16.0959C13.152 15.4639 12.64 14.9679 12.008 14.9679C11.36 14.9679 10.864 15.4639 10.864 16.0959C10.864 16.7039 11.36 17.2319 12.008 17.2319Z",
      fill: "currentColor"
    }
  ),
  "InformationIcon"
), e1 = /* @__PURE__ */ r(
  /* @__PURE__ */ t(
    "path",
    {
      d: "M9 7.001H22V4H9V7.001ZM3 7.001H6V4H3V7.001ZM9 13.001H22V10.001H9V13.001ZM3 13.001H6V10.001H3V13.001ZM9 19.001H22V16.001H9V19.001ZM3 19.001H6V16.001H3V19.001Z",
      fill: "currentColor"
    }
  ),
  "ListIcon"
), c1 = /* @__PURE__ */ r(
  /* @__PURE__ */ t(
    "path",
    {
      d: "M4 22V8H7V6C7 4.61667 7.4875 3.4375 8.4625 2.4625C9.4375 1.4875 10.6167 1 12 1C13.3833 1 14.5625 1.4875 15.5375 2.4625C16.5125 3.4375 17 4.61667 17 6V8H20V22H4ZM12 17C12.55 17 13.0208 16.8042 13.4125 16.4125C13.8042 16.0208 14 15.55 14 15C14 14.45 13.8042 13.9792 13.4125 13.5875C13.0208 13.1958 12.55 13 12 13C11.45 13 10.9792 13.1958 10.5875 13.5875C10.1958 13.9792 10 14.45 10 15C10 15.55 10.1958 16.0208 10.5875 16.4125C10.9792 16.8042 11.45 17 12 17ZM9 8H15V6C15 5.16667 14.7083 4.45833 14.125 3.875C13.5417 3.29167 12.8333 3 12 3C11.1667 3 10.4583 3.29167 9.875 3.875C9.29167 4.45833 9 5.16667 9 6V8Z",
      fill: "currentColor"
    }
  ),
  "LockIcon"
), o1 = /* @__PURE__ */ r(
  /* @__PURE__ */ t(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16.6177 14.4964C17.4901 13.215 18 11.6671 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18C11.667 18 13.215 17.4901 14.4964 16.6178L20 22.1213L22.1213 20L16.6177 14.4964ZM15 10C15 12.7614 12.7614 15 10 15C7.23858 15 5 12.7614 5 10C5 7.23858 7.23858 5 10 5C12.7614 5 15 7.23858 15 10Z",
      fill: "currentColor"
    }
  ),
  "MagnifierIcon"
), l1 = /* @__PURE__ */ r(
  /* @__PURE__ */ t(
    "path",
    {
      d: "M3 19H21V5H3V19ZM19.2142 6.75V8.5L11.9991 12.875L4.78485 8.5V6.75L11.9991 11.125L19.2142 6.75Z",
      fill: "currentColor"
    }
  ),
  "MailIcon"
), i1 = /* @__PURE__ */ r(
  /* @__PURE__ */ t(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M22.5255 7.1411L7.07067 3L5.00012 10.7274L12.2664 12.6744C13.1821 11.647 14.5156 11 16.0001 11C18.0679 11 19.8425 12.2552 20.6036 14.0452C20.6266 14.0487 20.6496 14.0524 20.6726 14.0563L22.5255 7.1411ZM4.07067 5L5.40364 5.35717L3.77521 11.4345L11.6444 13.5431C11.3661 14.0355 11.1688 14.5798 11.0707 15.1579L2.00012 12.7274L4.07067 5ZM19.4839 14.033C17.5186 14.2862 16.0001 15.9658 16.0001 18C16.0001 18.715 16.1877 19.3862 16.5164 19.967C16.3474 19.9888 16.1751 20 16.0001 20C13.791 20 12.0001 18.2091 12.0001 16C12.0001 13.7909 13.791 12 16.0001 12C17.4943 12 18.7971 12.8192 19.4839 14.033ZM23.0001 18C23.0001 19.6569 21.657 21 20.0001 21C18.3433 21 17.0001 19.6569 17.0001 18C17.0001 16.3431 18.3433 15 20.0001 15C21.657 15 23.0001 16.3431 23.0001 18ZM2 13.9272V19H11.9996C11.436 18.2497 11.0786 17.3356 11.0115 16.3419L2 13.9272Z",
      fill: "currentColor"
    }
  ),
  "MoneyIcon"
), n1 = /* @__PURE__ */ r(
  /* @__PURE__ */ t(
    "path",
    {
      d: "M4.5 9C5.881 9 7 10.119 7 11.5C7 12.881 5.881 14 4.5 14C3.119 14 2 12.881 2 11.5C2 10.119 3.119 9 4.5 9ZM12.5 9C13.881 9 15 10.119 15 11.5C15 12.881 13.881 14 12.5 14C11.119 14 10 12.881 10 11.5C10 10.119 11.119 9 12.5 9ZM20.5 9C21.881 9 23 10.119 23 11.5C23 12.881 21.881 14 20.5 14C19.119 14 18 12.881 18 11.5C18 10.119 19.119 9 20.5 9Z",
      fill: "currentColor"
    }
  ),
  "MoreIcon"
), h1 = /* @__PURE__ */ r(
  /* @__PURE__ */ t(c, { children: /* @__PURE__ */ e("g", { fill: "currentColor", children: [
    /* @__PURE__ */ t("rect", { height: "18", width: "2", x: "3", y: "3" }),
    /* @__PURE__ */ t("rect", { height: "2", width: "9", x: "3", y: "3" }),
    /* @__PURE__ */ t("rect", { height: "2", width: "7", x: "14", y: "3" }),
    /* @__PURE__ */ t("rect", { height: "2", width: "18", x: "3", y: "19" }),
    /* @__PURE__ */ t("rect", { height: "7", width: "2", x: "19", y: "3" }),
    /* @__PURE__ */ t("rect", { height: "9", width: "2", x: "19", y: "12" }),
    /* @__PURE__ */ t("g", { transform: "rotate(-45 12 12)", children: /* @__PURE__ */ t("rect", { height: "2", width: "14", x: "8", y: "11" }) })
  ] }) }),
  "OpenInNewIcon"
), d1 = /* @__PURE__ */ r(
  /* @__PURE__ */ e(c, { children: [
    /* @__PURE__ */ t("polygon", { fill: "currentColor", points: "3,21 3,17, 14,6 18,10, 7,21" }),
    /* @__PURE__ */ t("g", { transform: "rotate(45)", children: /* @__PURE__ */ t("rect", { fill: "currentColor", x: "14", y: "-11", width: "6", height: "3.5" }) })
  ] }),
  "PencilIcon"
), C1 = /* @__PURE__ */ r(
  /* @__PURE__ */ e(c, { children: [
    /* @__PURE__ */ e("defs", { children: [
      /* @__PURE__ */ t("clipPath", { id: "half-circle-people", children: /* @__PURE__ */ t("rect", { width: "24", height: "22", x: "0", y: "0" }) }),
      /* @__PURE__ */ t("clipPath", { id: "half-circle-right-people", children: /* @__PURE__ */ t("rect", { width: "24", height: "22", x: "15", y: "0" }) })
    ] }),
    /* @__PURE__ */ e("g", { fill: "currentColor", children: [
      /* @__PURE__ */ t("circle", { cx: "8", cy: "12", r: "3" }),
      /* @__PURE__ */ t("circle", { cx: "8", cy: "23", r: "7", clipPath: "url(#half-circle-people)" }),
      /* @__PURE__ */ t("circle", { cx: "18", cy: "12", r: "3" }),
      /* @__PURE__ */ t(
        "circle",
        {
          cx: "18",
          cy: "23",
          r: "7",
          clipPath: "url(#half-circle-right-people)"
        }
      )
    ] })
  ] }),
  "PeopleIcon"
), a1 = /* @__PURE__ */ r(
  /* @__PURE__ */ e(c, { children: [
    /* @__PURE__ */ t(
      "mask",
      {
        id: "mask0",
        style: { maskType: "alpha" },
        maskUnits: "userSpaceOnUse",
        x: "2",
        y: "2",
        width: "8",
        height: "7",
        children: /* @__PURE__ */ t(
          "path",
          {
            d: "M2.00005 2.00024H9.00069V8.99993H2.00005V2.00024Z",
            fill: "currentColor"
          }
        )
      }
    ),
    /* @__PURE__ */ t("g", { mask: "url(#mask0)", children: /* @__PURE__ */ t(
      "path",
      {
        d: "M8.3774 7.49235C7.2764 9.08135 5.0964 9.47735 3.5074 8.37735C1.9184 7.27635 1.5224 5.09635 2.6234 3.50735C3.7234 1.91835 5.9034 1.52235 7.4924 2.62335C9.0824 3.72335 9.4784 5.90335 8.3774 7.49235Z",
        fill: "currentColor"
      }
    ) }),
    /* @__PURE__ */ t(
      "mask",
      {
        id: "mask1",
        style: { maskType: "alpha" },
        maskUnits: "userSpaceOnUse",
        x: "15",
        y: "15",
        width: "8",
        height: "8",
        children: /* @__PURE__ */ t("path", { d: "M15.0001 15H22.0008V22.0002H15.0001V15Z", fill: "currentColor" })
      }
    ),
    /* @__PURE__ */ t("g", { mask: "url(#mask1)", children: /* @__PURE__ */ t(
      "path",
      {
        d: "M21.3774 20.4933C20.2764 22.0823 18.0964 22.4773 16.5074 21.3773C14.9184 20.2763 14.5224 18.0973 15.6234 16.5073C16.7234 14.9183 18.9034 14.5223 20.4934 15.6233C22.0824 16.7233 22.4784 18.9033 21.3774 20.4933Z",
        fill: "currentColor"
      }
    ) }),
    /* @__PURE__ */ t(
      "path",
      {
        d: "M18.0002 2.00049L2.0012 17.9995L6.0002 22.0005L22.0012 6.00049L18.0002 2.00049Z",
        fill: "currentColor"
      }
    )
  ] }),
  "PercentageIcon"
), s1 = /* @__PURE__ */ r(
  /* @__PURE__ */ e(c, { children: [
    /* @__PURE__ */ e("defs", { children: [
      /* @__PURE__ */ t("clipPath", { id: "halfCircleLeft", children: /* @__PURE__ */ t("rect", { width: "10", height: "24", x: "0", y: "0" }) }),
      /* @__PURE__ */ t("clipPath", { id: "pieTopRight", children: /* @__PURE__ */ t("rect", { width: "24", height: "10", x: "12", y: "0" }) }),
      /* @__PURE__ */ t("clipPath", { id: "pieBottomRight", children: /* @__PURE__ */ t("rect", { width: "12", height: "24", x: "12", y: "12" }) })
    ] }),
    /* @__PURE__ */ e("g", { fill: "currentColor", children: [
      /* @__PURE__ */ t("circle", { cx: "12", cy: "12", r: "10", clipPath: "url(#halfCircleLeft)" }),
      /* @__PURE__ */ t("circle", { cx: "12", cy: "12", r: "10", clipPath: "url(#pieTopRight)" }),
      /* @__PURE__ */ t("circle", { cx: "12", cy: "12", r: "10", clipPath: "url(#pieBottomRight)" })
    ] })
  ] }),
  "PieChartIcon"
), p1 = /* @__PURE__ */ r(
  /* @__PURE__ */ t(c, { children: /* @__PURE__ */ t(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18 2H6V22H18V2ZM10 3H14V4H10V3ZM13 20C13 20.5523 12.5523 21 12 21C11.4477 21 11 20.5523 11 20C11 19.4477 11.4477 19 12 19C12.5523 19 13 19.4477 13 20Z",
      fill: "currentColor"
    }
  ) }),
  "PhoneIcon"
), H1 = /* @__PURE__ */ r(
  /* @__PURE__ */ t(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4 4H20V15L15 10L9 16L7 14L4 17V4ZM2 22V2H22V22H2ZM11 9C11 10.1046 10.1046 11 9 11C7.89543 11 7 10.1046 7 9C7 7.89543 7.89543 7 9 7C10.1046 7 11 7.89543 11 9Z",
      fill: "currentColor"
    }
  ),
  "PhotoIcon"
), V1 = /* @__PURE__ */ r(
  /* @__PURE__ */ t("path", { d: "M2 10H22V14H2V10Z M10 22L10 2L14 2L14 22H10Z", fill: "currentColor" }),
  "PlusSignIcon"
), u1 = /* @__PURE__ */ r(
  /* @__PURE__ */ t(c, { children: /* @__PURE__ */ e("g", { fill: "currentColor", children: [
    /* @__PURE__ */ t("rect", { width: "8", height: "2", x: "7", y: "9" }),
    /* @__PURE__ */ t("rect", { width: "8", height: "2", x: "7", y: "12" }),
    /* @__PURE__ */ t("rect", { width: "8", height: "2", x: "7", y: "15" }),
    /* @__PURE__ */ t("rect", { width: "8", height: "2", x: "14", y: "5" }),
    /* @__PURE__ */ t("rect", { width: "2", height: "8", x: "17", y: "2" }),
    /* @__PURE__ */ t("rect", { width: "8", height: "2", x: "3", y: "5", rx: "1" }),
    /* @__PURE__ */ t("rect", { width: "5", height: "2", x: "7", y: "5" }),
    /* @__PURE__ */ t("rect", { width: "2", height: "16", x: "3", y: "5", rx: "1" }),
    /* @__PURE__ */ t("rect", { width: "16", height: "2", x: "3", y: "19", rx: "1" }),
    /* @__PURE__ */ t("rect", { width: "2", height: "4", x: "17", y: "12" }),
    /* @__PURE__ */ t("rect", { width: "2", height: "9", x: "17", y: "12", rx: "1" })
  ] }) }),
  "PostAddIcon"
), g1 = /* @__PURE__ */ r(
  /* @__PURE__ */ t(c, { children: /* @__PURE__ */ e("g", { fill: "currentColor", children: [
    /* @__PURE__ */ t("rect", { width: "12", height: "3", x: "6", y: "4" }),
    /* @__PURE__ */ t("rect", { width: "2", height: "3", x: "6", y: "17" }),
    /* @__PURE__ */ t("rect", { width: "12", height: "2", x: "6", y: "19" }),
    /* @__PURE__ */ t("rect", { width: "2", height: "3", x: "16", y: "17" }),
    /* @__PURE__ */ t("rect", { width: "6", height: "9", x: "2", y: "8" }),
    /* @__PURE__ */ t("rect", { width: "6", height: "2", x: "16", y: "8" }),
    /* @__PURE__ */ t("rect", { width: "2", height: "10", x: "16", y: "8" }),
    /* @__PURE__ */ t("rect", { width: "6", height: "5", x: "16", y: "12" }),
    /* @__PURE__ */ t("rect", { width: "2", height: "5", x: "20", y: "8" }),
    /* @__PURE__ */ t("rect", { width: "11", height: "6", x: "6", y: "8" }),
    /* @__PURE__ */ t(
      "circle",
      {
        cx: "19",
        cy: "11",
        r: "1.5",
        fill: "transparent",
        stroke: "currentColor"
      }
    )
  ] }) }),
  "PrintIcon"
), f1 = /* @__PURE__ */ r(
  /* @__PURE__ */ t(
    "path",
    {
      d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM13.1545 14.5136H10.9837V14.0529C10.9837 13.0443 11.4634 12.2502 12.1138 11.6784L12.9837 10.9239C13.561 10.4315 13.7967 9.97882 13.7967 9.53408C13.7967 8.38253 13.0894 7.91396 12.0406 7.91396C10.935 7.91396 10.2927 8.64461 10.1707 9.55791H8C8.1626 7.3501 9.79675 6 12.0569 6C14.1789 6 16 7.14361 16 9.56585C16 10.495 15.3496 11.2892 14.5203 11.9404L13.8699 12.4487C13.3496 12.8855 13.1545 13.5923 13.1545 14.45V14.5136ZM13.5854 16.634C13.5854 17.3647 12.9431 18 12.1707 18C11.374 18 10.7642 17.3647 10.7642 16.634C10.7642 15.9034 11.374 15.2998 12.1707 15.2998C12.9431 15.2998 13.5854 15.9034 13.5854 16.634Z",
      fill: "currentColor"
    }
  ),
  "QuestionMarkIcon"
), L1 = /* @__PURE__ */ r(
  /* @__PURE__ */ e(c, { children: [
    /* @__PURE__ */ e("defs", { children: [
      /* @__PURE__ */ t("clipPath", { id: "clip-2", children: /* @__PURE__ */ t("rect", { x: "10", y: "15", width: "24", height: "24" }) }),
      /* @__PURE__ */ t("clipPath", { id: "clip-3", children: /* @__PURE__ */ t("rect", { x: "0", y: "15", width: "24", height: "24" }) }),
      /* @__PURE__ */ t("clipPath", { id: "clip-4", children: /* @__PURE__ */ t("rect", { x: "0", y: "0", width: "12", height: "24" }) }),
      /* @__PURE__ */ t("clipPath", { id: "clip-5", children: /* @__PURE__ */ t("rect", { x: "10", y: "0", width: "12", height: "6" }) })
    ] }),
    /* @__PURE__ */ t(
      "circle",
      {
        id: "circle",
        cx: "12",
        cy: "11",
        r: "35%",
        strokeWidth: "2",
        fill: "transparent",
        style: { clipPath: "url(#clip-2)" },
        stroke: "currentColor"
      }
    ),
    /* @__PURE__ */ t(
      "circle",
      {
        id: "circle",
        cx: "12",
        cy: "11",
        r: "35%",
        strokeWidth: "2",
        fill: "transparent",
        style: { clipPath: "url(#clip-3)" },
        stroke: "currentColor"
      }
    ),
    /* @__PURE__ */ t(
      "circle",
      {
        id: "circle",
        cx: "12",
        cy: "11",
        r: "35%",
        strokeWidth: "2",
        fill: "transparent",
        style: { clipPath: "url(#clip-4)" },
        stroke: "currentColor"
      }
    ),
    /* @__PURE__ */ t(
      "circle",
      {
        id: "circle",
        cx: "12",
        cy: "11",
        r: "35%",
        strokeWidth: "2",
        fill: "transparent",
        style: { clipPath: "url(#clip-5)" },
        stroke: "currentColor"
      }
    ),
    /* @__PURE__ */ t(
      "polygon",
      {
        id: "polygon",
        fill: "currentColor",
        points: "21,2 21,10 13,10"
      }
    )
  ] }),
  "RefreshIcon"
), M1 = /* @__PURE__ */ r(
  /* @__PURE__ */ t(c, { children: /* @__PURE__ */ t("g", { fill: "currentColor", children: /* @__PURE__ */ t("rect", { height: "2", width: "14", x: "5", y: "11" }) }) }),
  "RemoveIcon"
), I1 = /* @__PURE__ */ r(
  /* @__PURE__ */ t(
    "path",
    {
      d: "M16.95 7.0475C14.21 4.3175 9.78 4.3175 7.05 7.0475C5.68 8.4175 5 10.2075 5 11.9975V12.9975M5 12.9975L8 9.9975M5 12.9975L2 9.9975M7.05 16.9475C9.78 19.6775 14.22 19.6775 16.95 16.9475C18.32 15.5775 19 13.7875 19 11.9975V10.9975M19 10.9975L16 13.9975M19 10.9975L22 13.9975",
      stroke: "currentColor",
      strokeWidth: "2"
    }
  ),
  "RenewIcon"
), y1 = /* @__PURE__ */ r(
  /* @__PURE__ */ t(
    "path",
    {
      d: "M11 2H3V4H5V5H3V7H5V8H3V10H5V11H3V13H5V14H3V22H21V15L11 15V2Z",
      fill: "currentColor"
    }
  ),
  "RulerIcon"
), x1 = /* @__PURE__ */ r(
  /* @__PURE__ */ t(
    "path",
    {
      d: "M9.5 15C11.432 15 13 16.567 13 18.5C13 18.671 12.973 18.835 12.949 19H20V22H4V19H6.051C6.026 18.835 6 18.671 6 18.5C6 16.567 7.567 15 9.5 15ZM15.5 9C17.433 9 19 10.567 19 12.5C19 14.433 17.433 16 15.5 16C13.567 16 12 14.433 12 12.5C12 10.567 13.567 9 15.5 9ZM10.5 2C12.433 2 14 3.567 14 5.5C14 7.433 12.433 9 10.5 9C8.567 9 7 7.433 7 5.5C7 3.567 8.567 2 10.5 2Z",
      fill: "currentColor"
    }
  ),
  "SavingsAccountIcon"
), Z1 = /* @__PURE__ */ r(
  /* @__PURE__ */ e(c, { children: [
    /* @__PURE__ */ t("defs", { children: /* @__PURE__ */ t("clipPath", { id: "clip-bottom", children: /* @__PURE__ */ t("rect", { x: "0", y: "0", width: "24", height: "10" }) }) }),
    /* @__PURE__ */ e("g", { fill: "currentColor", children: [
      /* @__PURE__ */ t("rect", { x: "1", y: "5", width: "22", height: "2", rx: "1" }),
      /* @__PURE__ */ t("rect", { x: "1", y: "5", width: "3", height: "14", rx: "1" }),
      /* @__PURE__ */ t("rect", { x: "3", y: "5", width: "2", height: "14", rx: "1" }),
      /* @__PURE__ */ t("rect", { x: "1", y: "17", width: "22", height: "2", rx: "1" }),
      /* @__PURE__ */ t("rect", { x: "21", y: "5", width: "2", height: "14", rx: "1" }),
      /* @__PURE__ */ t("rect", { x: "19", y: "5", width: "3", height: "14", rx: "1" }),
      /* @__PURE__ */ t("rect", { x: "9", y: "11", width: "6", height: "5", rx: "1" }),
      /* @__PURE__ */ t("rect", { x: "10", y: "10", width: "1", height: "2" }),
      /* @__PURE__ */ t("rect", { x: "13", y: "10", width: "1", height: "2" }),
      /* @__PURE__ */ t(
        "circle",
        {
          cx: "12",
          cy: "10",
          r: "1.5",
          fill: "transparent",
          stroke: "currentColor",
          strokeWidth: "1",
          style: { clipPath: "url(#clip-bottom)" }
        }
      )
    ] })
  ] }),
  "ScreenLockLandscapeIcon"
), w1 = /* @__PURE__ */ r(
  /* @__PURE__ */ t(
    "path",
    {
      d: "M16.5 10C16.5 13.5899 13.5899 16.5 10 16.5C6.41015 16.5 3.5 13.5899 3.5 10C3.5 6.41015 6.41015 3.5 10 3.5C13.5899 3.5 16.5 6.41015 16.5 10Z M20 20L15 15",
      stroke: "currentColor",
      strokeWidth: "3",
      strokeLinecap: "round"
    }
  ),
  "SearchIcon"
), k1 = /* @__PURE__ */ r(
  /* @__PURE__ */ e(c, { children: [
    /* @__PURE__ */ t("path", { d: "M12 5L7 10H17L12 5Z", fill: "currentColor" }),
    /* @__PURE__ */ t("path", { d: "M12 19L7 14H17L12 19Z", fill: "currentColor" })
  ] }),
  "SelectIcon"
), m1 = /* @__PURE__ */ r(
  /* @__PURE__ */ t(c, { children: /* @__PURE__ */ e("g", { fill: "currentColor", children: [
    /* @__PURE__ */ t("rect", { height: "11", width: "2", x: "4", y: "4" }),
    /* @__PURE__ */ t("rect", { height: "2", width: "13", x: "4", y: "14" }),
    /* @__PURE__ */ t("rect", { height: "2", width: "9", x: "10", y: "9", transform: "rotate(45 12 12)" }),
    /* @__PURE__ */ t("rect", { height: "2", width: "9", x: "6", y: "17", transform: "rotate(-45 12 12)" })
  ] }) }),
  "SubdirectoryArrowRightIcon"
), R1 = /* @__PURE__ */ r(
  /* @__PURE__ */ t(
    "path",
    {
      d: "M7 12L10 15L17 8M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z",
      stroke: "currentColor",
      strokeWidth: "2"
    }
  ),
  "SuccessRingIcon"
), v1 = /* @__PURE__ */ r(
  /* @__PURE__ */ t(
    "path",
    {
      d: "M14.17 1L7 8.18V21H19.31L23 12.4V8H14.69L15.81 2.62L14.17 1ZM1 9H5V21H1V9Z",
      fill: "currentColor",
      transform: "rotate(180 12 12)"
    }
  ),
  "ThumbsDownIcon"
), l = /* @__PURE__ */ r(
  /* @__PURE__ */ t(
    "path",
    {
      d: "M14.17 1L7 8.18V21H19.31L23 12.4V8H14.69L15.81 2.62L14.17 1ZM1 9H5V21H1V9Z",
      fill: "currentColor"
    }
  ),
  "ThumbsUpIcon"
), P1 = /* @__PURE__ */ o(
  l,
  "ThumbUpIcon"
), A1 = /* @__PURE__ */ r(
  /* @__PURE__ */ t(
    "path",
    {
      d: "M16 2V3C16 5.209 14.209 7 12 7C9.791 7 8 5.209 8 3V2H6V17H8V18C8 20.209 9.791 22 12 22C14.209 22 16 20.209 16 18V17H18V2H16Z",
      fill: "currentColor"
    }
  ),
  "TicketIcon"
), W1 = /* @__PURE__ */ r(
  /* @__PURE__ */ t(c, { children: /* @__PURE__ */ e("g", { fill: "currentColor", children: [
    /* @__PURE__ */ t("circle", { cx: "3", cy: "16", r: "2" }),
    /* @__PURE__ */ t("circle", { cx: "10", cy: "9", r: "2" }),
    /* @__PURE__ */ t("circle", { cx: "16", cy: "15", r: "2" }),
    /* @__PURE__ */ t("circle", { cx: "21", cy: "8", r: "2" }),
    /* @__PURE__ */ t(
      "rect",
      {
        transform: "rotate(45 12 12)",
        width: "2",
        height: "8",
        x: "7.5",
        y: "12"
      }
    ),
    /* @__PURE__ */ t(
      "rect",
      {
        transform: "rotate(-45 12 12)",
        width: "2",
        height: "11",
        x: "11.5",
        y: "7"
      }
    ),
    /* @__PURE__ */ t(
      "rect",
      {
        transform: "rotate(36 12 12)",
        width: "2",
        height: "8",
        x: "16",
        y: "4"
      }
    )
  ] }) }),
  "TimelineIcon"
), b1 = /* @__PURE__ */ r(
  /* @__PURE__ */ e(c, { children: [
    /* @__PURE__ */ t("rect", { fill: "currentColor", x: "3", y: "6.5", width: "15", height: "3" }),
    /* @__PURE__ */ t("polygon", { fill: "currentColor", points: "18,4 22,8 18,12" }),
    /* @__PURE__ */ t("rect", { fill: "currentColor", x: "4", y: "14.5", width: "17", height: "3" }),
    /* @__PURE__ */ t("polygon", { fill: "currentColor", points: "6,12 6,20 2,16" })
  ] }),
  "TransferIcon"
), T1 = /* @__PURE__ */ r(
  /* @__PURE__ */ t(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18.2778 7.71273C18.1828 7.64773 18.0788 7.60573 17.9808 7.54873C17.8478 5.80873 16.9628 4.13973 15.4158 3.06773C12.6918 1.18173 8.95484 1.85973 7.06784 4.58473C6.01284 6.10773 5.76184 7.94673 6.21984 9.60373C5.96384 9.79273 5.72584 10.0167 5.53384 10.2927C4.59084 11.6547 4.92984 13.5247 6.29284 14.4677C7.45784 15.2747 8.98984 15.1357 10.0008 14.2277V22.0007H14.0008V14.4427C15.7858 15.4817 18.0918 15.0057 19.2888 13.2777C20.5468 11.4627 20.0938 8.97073 18.2778 7.71273Z",
      fill: "currentColor"
    }
  ),
  "TreeIcon"
), D1 = /* @__PURE__ */ r(
  /* @__PURE__ */ t(c, { children: /* @__PURE__ */ t(
    "path",
    {
      d: "M12.0002 17.625V15.375M12.0002 14.25L12.0002 6.375M4.16119 19.9975H19.1694C20.709 19.9975 21.6713 18.3308 20.9015 16.9975L13.3973 4C12.6275 2.66666 10.703 2.66667 9.93324 4L2.42914 16.9975C1.65934 18.3308 2.62159 19.9975 4.16119 19.9975Z",
      stroke: "currentColor",
      strokeWidth: "2"
    }
  ) }),
  "TriangleWarningIcon"
), S1 = /* @__PURE__ */ r(
  /* @__PURE__ */ t(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11 7.81425L8.70715 10.1071L7.29294 8.69289L12 3.98578L16.7072 8.69289L15.2929 10.1071L13 7.81416L13 17.4L11 17.4L11 7.81425ZM4 14H6V19H18V14H20V21H4V14Z",
      fill: "currentColor"
    }
  ),
  "UploadInlineIcon"
), q1 = /* @__PURE__ */ r(
  /* @__PURE__ */ t(
    "path",
    {
      d: "M17 7C17 9.76142 14.7614 12 12 12C9.23858 12 7 9.76142 7 7C7 4.23858 9.23858 2 12 2C14.7614 2 17 4.23858 17 7ZM3 22C3 17.0294 7.02944 13 12 13C16.9706 13 21 17.0294 21 22H3Z",
      fill: "currentColor"
    }
  ),
  "UserIcon"
), E1 = /* @__PURE__ */ r(
  /* @__PURE__ */ t(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6 8.5L13.7799 1.5L19 7.48182L17.8581 8.5H6ZM3 9.50008H21V11.6442V21.5H18.561H3V9.50008ZM17 15.5C17 16.0523 17.4477 16.5 18 16.5C18.5523 16.5 19 16.0523 19 15.5C19 14.9477 18.5523 14.5 18 14.5C17.4477 14.5 17 14.9477 17 15.5Z",
      fill: "currentColor"
    }
  ),
  "WalletIcon"
), U1 = /* @__PURE__ */ r(
  /* @__PURE__ */ t(c, { children: /* @__PURE__ */ e("g", { fill: "currentColor", children: [
    /* @__PURE__ */ t("polygon", { points: "1,21 23,21, 13,18 11,18" }),
    /* @__PURE__ */ t("polygon", { points: "1,21 12,2 11,10 11,20" }),
    /* @__PURE__ */ t("polygon", { points: "23,21 12,2 13,10 13,20" }),
    /* @__PURE__ */ t("polygon", { points: "14,10 12,2 10,10" }),
    /* @__PURE__ */ t("rect", { width: "4", height: "2", x: "10", y: "14" })
  ] }) }),
  "WarningIcon"
), B1 = /* @__PURE__ */ r(
  /* @__PURE__ */ t(
    "path",
    {
      d: "M16 16L8 8M8 16L16 8M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z",
      stroke: "currentColor",
      strokeWidth: "2"
    }
  ),
  "XRingIcon"
);
export {
  n1 as $,
  h as A,
  V as B,
  g as C,
  v as D,
  S as E,
  U as F,
  B as G,
  F as H,
  j as I,
  G as J,
  O as K,
  N as L,
  Q as M,
  X as N,
  z as O,
  J as P,
  K as Q,
  Y as R,
  _ as S,
  $ as T,
  t1 as U,
  r1 as V,
  e1 as W,
  c1 as X,
  o1 as Y,
  l1 as Z,
  i1 as _,
  d as a,
  h1 as a0,
  d1 as a1,
  C1 as a2,
  a1 as a3,
  s1 as a4,
  p1 as a5,
  H1 as a6,
  V1 as a7,
  u1 as a8,
  g1 as a9,
  f1 as aa,
  L1 as ab,
  M1 as ac,
  I1 as ad,
  y1 as ae,
  x1 as af,
  Z1 as ag,
  w1 as ah,
  k1 as ai,
  m1 as aj,
  R1 as ak,
  v1 as al,
  l as am,
  P1 as an,
  A1 as ao,
  W1 as ap,
  b1 as aq,
  T1 as ar,
  D1 as as,
  S1 as at,
  q1 as au,
  E1 as av,
  U1 as aw,
  B1 as ax,
  C as b,
  a as c,
  s as d,
  p as e,
  H as f,
  u as g,
  f as h,
  L as i,
  M as j,
  I as k,
  y as l,
  x as m,
  Z as n,
  w as o,
  k as p,
  m as q,
  R as r,
  P as s,
  A as t,
  W as u,
  b as v,
  T as w,
  D as x,
  q as y,
  E as z
};
//# sourceMappingURL=XRingIcon-Cm47j4hs.mjs.map
